var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[_c('SectionHeader',{attrs:{"stretchable":false,"is-deletable":false,"info-text":'Community description',"title":'Community'},on:{"setStatic":function($event){return _vm.$emit('setStatic', $event)}}}),_c('div',{staticClass:"layout-item-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }